import React, {useCallback, useMemo, useState} from 'react';
import SiloModelCanvas from './SiloModelCanvas';
import GrainSiloSensorInfoPanel from './GrainSiloSensorInfoPanel';
import SiloHeatMap from "./SiloHeatMap";
import {CustomButton} from "../../../components/Button";


// Example structure of the parent component
const GrainSiloDeviceView = ({ ws_data }) => {

    // State to track which sensor is highlighted (by ID)
    const [selectedSensorIds, setSelectedSensorIds] = useState<Array<string | number>>([]);
      const handleClearAll = useCallback(() => {
        setSelectedSensorIds([]);

    }, []);

    // Function to handle clicks from BOTH the 3D model and the 2D blocks
    const allSensorsMap = useMemo(() => {
        const map = new Map<string | number, any>();
        ws_data?.groups?.forEach((group: any) => {
            group.sensors?.forEach((sensor: any) => {
                map.set(sensor.Id, {
                    ...sensor,
                    group,
                    tempValue: sensor.Value && sensor.Meta?.Units ? `${sensor.Value} ${sensor.Meta.Units}` : 'No Reading'
                });
            });
        });
        return map;
    }, [ws_data]);

const handleClosePanel = useCallback((sensorIdToRemove: string | number) => {
    // This uses the same logic as deselection to remove the ID from the array
    setSelectedSensorIds(prevIds => prevIds.filter(id => id !== sensorIdToRemove));
}, []);

const handleSensorInteraction = useCallback((sensorId: string | number) => {

    // 1. Check if the incoming ID is already in the selected list
 setSelectedSensorIds(prevIds => {
        const isSelected = prevIds.includes(sensorId);

        if (isSelected) {
            // If deselecting, just remove it from the array.
            return prevIds.filter(id => id !== sensorId);
        } else {
            // If selecting, add it to the array AND mark it as the last clicked.
           if (allSensorsMap.has(sensorId)) {
                    return [...prevIds, sensorId];
                }
                return prevIds;
        }
    });

    // 2. Set the data for the INFO PANEL based on the LAST sensor clicked



}, [allSensorsMap]);
const liveSelectedSensorData = selectedSensorIds
        .map(id => allSensorsMap.get(id))
        .filter(sensor => sensor !== undefined);

    if (!ws_data) {
        return <div>Loading sensor data...</div>;
    }

    return (
        <div style={{
            display: 'flex',
            width: '100%',
            minHeight: '800px',
            gap: '20px',
            padding: '10px'
        }}>

            <div style={{flex: '0 0 45%', display: 'flex', flexDirection: 'column', gap: '20px'}}>

                    {liveSelectedSensorData.length > 0 && (
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <span style={{
                                fontSize: '18px',
                                margin: 0,
                                visibility: 'hidden'
                            }}>Selected Sensor Details</span>
                            <CustomButton width="120px"
                                          height="30px"
                                          padding="0"
                                          htmlType="button"
                                          onClick={handleClearAll}
                                          className="mar-right-10"
                                          color="red">
                                <span>Clear All ({liveSelectedSensorData.length})</span>
                            </CustomButton>
                               </div>
                            )}

                        <div style={{overflowY: 'auto', paddingRight: '10px'}}>

                {liveSelectedSensorData.length > 0 ? (
                    liveSelectedSensorData.map((sensor) => (
                        <GrainSiloSensorInfoPanel
                                key={sensor.Id}
                                sensor={sensor}
                                onClose={handleClosePanel}
                            />
                        ))
                    ) : (
                        <GrainSiloSensorInfoPanel sensor={null} onClose={handleClosePanel}/>
                    )}
                </div>

                <div style={{flexGrow: 1, minHeight: '850px', border: '1px solid #ddd'}}>
                    <SiloModelCanvas
                        key={ws_data.device.id}
                        wsData={ws_data}
                        onSensorClick={handleSensorInteraction}
                        selectedSensorIds={selectedSensorIds}

                    />
                </div>
            </div>

            {ws_data && ws_data?.groups?.map((item, index) => (
                item.sensors != null &&
                <SiloHeatMap sensors={item.sensors} onSensorClick={handleSensorInteraction}
                             selectedSensors={selectedSensorIds} groupName={item.Name} key={item.Id || index}/>

            ))
            }


        </div>
    );
};

export default GrainSiloDeviceView;